// extracted by mini-css-extract-plugin
export var container = "styles-module--container--399b2";
export var content = "styles-module--content--6caba";
export var logo = "styles-module--logo--9e3de";
export var section = "styles-module--section--d23ad";